import React from "react";

export default class Button extends React.PureComponent {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
  }

  onClick(e) {
    var { onClick } = this.props;
    e.preventDefault();
    if (onClick) {
      onClick(e);
    }
  }

  render() {
    var { children } = this.props;
    return (
      <button {...this.props} href="#" onClick={this.onClick} type="button">
        {children}
      </button>
    );
  }
}
